// ES5 JS extension and Libraries
import "./jquery-global.js"
import "./../../../../../../Packages/Plugins/TechDivision.ResponsiveImages/Resources/Private/JavaScript/Modules/picturefill.js"
import "./../../../../../../Packages/Plugins/TechDivision.Video/Resources/Private/JavaScript/Video.js"
import "./../../../../../../Packages/Plugins/TechDivision.Carousel/Resources/Public/Scripts/Scripts.js"

// Modules
import { Navigation } from "./Modules/Navigation.js";

const initNodeTypesOnLoad = function () {
    new Navigation;
}

if (document.readyState != 'loading') {
    initNodeTypesOnLoad();
} else {
    document.addEventListener('DOMContentLoaded', initNodeTypesOnLoad);
}

